import { CheckBox } from "@mui/icons-material";
import {
  Button,
  DialogActions,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useAddServiceMutation } from "src/api/servicesApiSlice";

const AddEditService = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { subject, action, id } = props;
  const data = useSelector(
    (state) => state.servicesApi.queries["getServices(undefined)"].data
  );
  console.log(data);
  const [addService, { isLoading: isUpdating }] = useAddServiceMutation();
  const {
    register,
    handleSubmit,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: data.filter((datum) => datum._id == id)[0],
  });

  const onSubmit = (data) => {
    addService({ ...data, alwaysAvailable: true });
  };
  const handleClose = () => {
    setSearchParams({});
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          {/* <form id="AddEditForm" onSubmit={handleSubmit(onSubmit)}> */}

          <Stack spacing={2} width={400}>
            <TextField
              label="Offering Name"
              type="text"
              {...register("name", {
                required: "Name of offering is required",
              })}
              error={!!errors.name}
              helperText={errors.name?.message}
            />
            <TextField
              label="Offering Description"
              type="text"
              {...register("description", {
                required: "Offering description is required",
              })}
              error={!!errors.description}
              helperText={errors.description?.message}
            />
            <TextField
              label="Cost"
              type="text"
              {...register("cost", { required: "Cost is required" })}
              error={!!errors.cost}
              helperText={errors.cost?.message}
            />
            <TextField
              label="Currency"
              type="text"
              {...register("currency", { required: "Currency is required" })}
              error={!!errors.currency}
              helperText={errors.currency?.message}
            />

            {/* <Button variant="contained" component="label">
              Upload Offering Images
              <input
                type="file"
                multiple
                hidden
                {...register("images")}
                error={!!errors.images}
                helperText={errors.images?.message}
              />
            </Button> */}

            {/* <FormGroup>
              <FormControlLabel
                control={
                  <CheckBox
                    defaultChecked
                    {...register("alwaysAvailable", {
                      required: "Available is required",
                    })}
                    error={!!errors.alwaysAvailable}
                    helperText={errors.alwaysAvailable?.message}
                  />
                }
                label="Always available?"
              />
            </FormGroup> */}
          </Stack>
          {/* <Button
            // onClick={onSubmit}
            type="submit"
          >
            Save
          </Button> */}
        </DialogContent>
        <DialogActions>
          {action == "add" || action == "edit" ? (
            <Button onClick={handleSubmit(onSubmit)} type="submit">
              Save
            </Button>
          ) : null}
          <Button variant="outlined" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>{" "}
      </form>
    </>
  );
};

export { AddEditService };
